import { AppBar, IconButton, Toolbar } from "@material-ui/core";
import styled from "styled-components";
import { TypeAppliedTheme } from "@src/Stores/Themes/types";

export const STAppBar = styled(AppBar)`
  height: 64px;
  box-shadow: 0 1px 6px -1px rgb(0 0 0 / 10%) !important;
  border-bottom: 1px solid #ddd !important;
  &&& {
    background-color: ${(props: { theme: TypeAppliedTheme }) => props.theme.applicationThemeDetails.primaryColor};
    color: ${(props: { theme: TypeAppliedTheme }) => props.theme.applicationThemeDetails.primaryTextColor};
  };
`;

export const NavbarLogoContainer = styled.div`    
    > img {
        height: 25px;
        display: flex;
        align-items: center;
    };
`;

export const STProfileIcon = styled.span`    
    background-color: ${(props: { theme: TypeAppliedTheme }) => props.theme.applicationThemeDetails.primaryTextColor} !important;
    color: ${(props: { theme: TypeAppliedTheme }) => props.theme.applicationThemeDetails.primaryColor} !important;
    display: flex;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    font-size: 13px;
    align-items: center;
    justify-content: center;
`;

export const RightIconBox = styled.div`
  display: flex;
  align-items: center;
  margin-left: auto;
`;

export const StyledToolbar = styled(Toolbar)`
    padding: 0 8px 0 20px;
`;

export const STProfileBox = styled(IconButton)`
  &&& {
    padding: 7px 12px 7px 10px;
    border-radius: 16px;
  }
`;
